/*
 * Function to retrieve url with params appended in case cookies are not active
 */
export default function getAjaxUrl(url) {
  if (typeof window.CFSession !== 'undefined') {
    if (url.indexOf('?') !== -1) {
      return `${url}&${window.CFSession.UrlToken}`;
    } else {
      return `${url}?${window.CFSession.UrlToken}`;
    }
  }

  return url;
}
